import { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from './ui/button';

export default function InstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('pwa-install-dismissed') === '1');

  useEffect(() => {
    const handleInstall = (event) => {
      event.preventDefault();
      setInstallEvent(event);
    };
    window.addEventListener('beforeinstallprompt', handleInstall);
    return () => window.removeEventListener('beforeinstallprompt', handleInstall);
  }, []);

  if (!installEvent || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem('pwa-install-dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-slate-900 p-4 text-white shadow-2xl">
      <Download className="h-5 w-5 shrink-0" />
      <p className="flex-1 text-sm font-medium">Install Revusathi for quick access.</p>
      <Button size="sm" variant="secondary" onClick={async () => {
        try {
          installEvent.prompt();
          const choice = await installEvent.userChoice;
          if (choice.outcome === 'accepted') dismiss();
          else setInstallEvent(null);
        } catch {
          setInstallEvent(null);
        }
      }}>Install</Button>
      <button aria-label="Dismiss install prompt" onClick={dismiss}><X className="h-5 w-5" /></button>
    </div>
  );
}
